import { getCoordinatorApi } from "@/lib/api";
import type {
  PartialUpdateProjectFormData,
  Project,
  SingleProjectResponse,
} from "../types";

export async function updateProject(
  data: PartialUpdateProjectFormData,
  organizationId: string
): Promise<Project> {
  const api = getCoordinatorApi({ organizationId });
  const { project_id, ...rest } = data;
  const response = await api.put<SingleProjectResponse>(
    `/projects/${project_id}`,
    rest
  );
  return response.data.data;
}
